import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FunilIaPhysics } from './components/FunilIaPhysics';

// Lazy import FunilIaSlides to avoid circular dependency
const FunilIaSlides = React.lazy(() =>
  import('../../pages/FunilIaSlides/FunilIaSlides').then((m) => ({
    default: m.FunilIaSlides,
  }))
);

export interface FunilIaRouterProps {
  onOpenLead?: (leadId: string) => void;
}

/**
 * Routes between FunilIaPhysics and FunilIaSlides
 * based on organization.funilVisualizacao setting.
 * Default is 'physics' for new organizations.
 */
export const FunilIaRouter: React.FC<FunilIaRouterProps> = ({ onOpenLead }) => {
  const { organization } = useAuth();
  const mode = organization?.funilVisualizacao ?? 'physics';

  if (mode === 'slides') {
    return (
      <React.Suspense fallback={<div style={{ padding: 20 }}>Carregando…</div>}>
        <FunilIaSlides onOpenLead={onOpenLead} />
      </React.Suspense>
    );
  }

  return <FunilIaPhysics onOpenLead={onOpenLead} />;
};
